
const KeyPressOnlyNumeric = (event: React.KeyboardEvent) => {
    if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
    }
};

export default KeyPressOnlyNumeric;